import { render, staticRenderFns } from "./ForumStatsContainer.vue?vue&type=template&id=49dcd05e&scoped=true&"
import script from "./ForumStatsContainer.vue?vue&type=script&lang=js&"
export * from "./ForumStatsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ForumStatsContainer.vue?vue&type=style&index=0&id=49dcd05e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dcd05e",
  null
  
)

export default component.exports